<mojo-widget [title]="widget.title" [showWidgetControls]="true" [widget]="widget">
  <ng-container widget-body>
    <div *ngIf="!showMap">
        No Map Available
    </div>
    <div #map class="property-map-container">
    </div>
  </ng-container>
</mojo-widget>


